import { configureStore } from '@reduxjs/toolkit';

import rootReducer, { combinedReducers, StoreState } from './reducers/root';
import { agentsApi } from './rest/agentsApi';
import { chatsApi } from './rest/chatsApi';
import { threadsApi } from './rest/threadsApi';
import { authApi } from './rest/authApi';
import { chatbotsApi } from './rest/chatbots';
import { configApi } from './rest/configApi';
import { credentialApi } from './rest/credentialApi';
import { customersApi } from './rest/customersApi';
import { paymentApi } from './rest/paymentApi';
import { statisticApi } from './rest/statisticApi';
import { userApi } from './rest/userApi';
import { utilitiesApi } from './rest/utilities';
import { workflowHistoryApi } from './rest/workflowHistoryApi';

const middlewares: any[] = [
  authApi.middleware,
  customersApi.middleware,
  userApi.middleware,
  credentialApi.middleware,
  agentsApi.middleware,
  chatsApi.middleware,
  threadsApi.middleware,
  utilitiesApi.middleware,
  statisticApi.middleware,
  paymentApi.middleware,
  configApi.middleware,
  chatbotsApi.middleware,
  workflowHistoryApi.middleware,
];

export const store = configureStore({
  reducer: combinedReducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      reducer: rootReducer,
      thunk: true,
      immutableCheck: false,
      serializableCheck: false,
    }).concat(...middlewares),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export type StoreType = StoreState;
